export const environment = {
  production: false,
  API_BASE_URL: 'https://prediction-market-api.blockchainx.tech/api/v1/admin/',
  UMA_ADAPTER_ADDRESS: "0x1Ce36689BB9BC3c9720222AA24618Ab3d4924eCa",
  USDC_ADDRESS: "0x41E94Eb019C0762f9Bfcf9Fb1E58725BfB0e7582",
  PROJECT_ID: "ec64c8099aaec0d9d05bf0dbf05d9186",
  PROJECT_URL: 'https://prediction-market-api.blockchainx.tech/api/v1/admin/',
  TRADING_ENGINE_URL: 'https://prediction-market-trade-engine.blockchainx.tech/',
  REWARD_TOKEN_AMOUNT: 1,  // <-- number
  PROPOSAL_BOND: 1.5,         // <-- number
  LIVENESS_PERIOD: 2,
  PROVIDERS: { polygonamoy: 'https://rpc-amoy.polygon.technology' },
  ADMIN_WALLET_ADDRESSES: [
    '0x0b2e2370Af67c95629bDAcdf9Fc8f423354bc392'
  ]
};